import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddTodo = () => {
    const [title, setTitle] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Handle form submission to create a new todo
    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(''); // Clear any previous error

        if (!title) {
            setError('Title is required');
            return;
        }

        const newTodo = {
            staff_id: 1, // Static staff_id set to 1
            title,
        };

        try {
            const response = await fetch(`${BASE_URL}todos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newTodo),
            });

            const data = await response.json();

            if (data.status === 1) {
                alert('Todo added successfully');
                navigate('/TodoList'); // Redirect to the Todo list page after successful addition
            } else {
                setError(data.message || 'An error occurred while adding the todo');
            }
        } catch (error) {
            setError('An error occurred while adding the todo');
            console.error('Error adding todo:', error);
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Todo</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add New Todo</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="title" className="form-label">Title</label>
                                        <input
                                            type="text"
                                            id="title"
                                            className="form-control"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Enter todo title"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <button type="submit" className="btn btn-primary">Add Todo</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddTodo;
